function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 20,
  height: 13.75,
  fill: "#EEF3F8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  width: 11.25,
  height: 8.75,
  fill: "#41479B"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 11.25,
  width: 8.75,
  height: 1.25,
  fill: "#DC251C"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 11.25,
  y: 2.5,
  width: 8.75,
  height: 1.25,
  fill: "#DC251C"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 11.25,
  y: 5,
  width: 8.75,
  height: 1.25,
  fill: "#DC251C"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 11.25,
  y: 7.5,
  width: 8.75,
  height: 1.25,
  fill: "#DC251C"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  y: 10,
  width: 20,
  height: 1.25,
  fill: "#DC251C"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  y: 12.5,
  width: 20,
  height: 1.25,
  fill: "#DC251C"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1.25,
  y: 1.25,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 3.75,
  y: 1.25,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6.25,
  y: 1.25,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 8.75,
  y: 1.25,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1.25,
  y: 3.75,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 3.75,
  y: 3.75,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref16 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6.25,
  y: 3.75,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  x: 2.5,
  y: 5,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 5,
  y: 5,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 7.5,
  y: 5,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 2.5,
  y: 2.5,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 5,
  y: 2.5,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref22 =
/*#__PURE__*/
React.createElement("rect", {
  x: 7.5,
  y: 2.5,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 8.75,
  y: 3.75,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1.25,
  y: 6.25,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref25 =
/*#__PURE__*/
React.createElement("rect", {
  x: 3.75,
  y: 6.25,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6.25,
  y: 6.25,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 8.75,
  y: 6.25,
  width: 1.25,
  height: 1.25,
  fill: "#C5D0EC"
});

var SvgIconFlagEnDark = function SvgIconFlagEnDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFlagEnDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_flag_en_dark.7f0d0397.svg";
export { ForwardRef as ReactComponent };